import { CargoTemperatureLogDateBM } from '../../types/BusinessModel/CargoTempLog/CargoTemperatureLogDateBM';
import { CargoTemperatureLogDate } from '../../types/ViewModel/CargoTempLog/CargoTemperatureLogDate';
import { formatQueryDateOnly } from '../../utils/aol/aolDateUtils';
import { getDateFromISO } from 'odfjell-date-time-utils/dateTimeUtils';
import { mapCargoTemperatureLogBms, mapCargoTemperatureLogs } from './CargoTempLogFactory';

export const mapCargoTempLogDate = (bm: CargoTemperatureLogDateBM): CargoTemperatureLogDate => {
    return {
        logDateId: bm.logDateId,
        imoNumber: bm.imoNumber,
        logDate: getDateFromISO(bm.logDate),
        isComplete: bm.isComplete,
        lastUpdatedUtc: bm.lastUpdatedUtc,
        lastUpdatedBy: bm.lastUpdatedBy,
        cargoInTankList: bm.cargoInTankList,
        cargoTemperatureLog: bm.cargoTemperatureLog ? mapCargoTemperatureLogs(bm.cargoTemperatureLog) : null,
        isValidated: bm.isComplete,
    };
};

export const mapCargoTempLogDates = (bms: CargoTemperatureLogDateBM[], offlineCargoTempLogDates?: any[]): CargoTemperatureLogDate[] => {
    if (!bms) return [];

    addOfflineDataToCargoTempLogDates(bms, offlineCargoTempLogDates ?? []);

    return bms.map((bm) => mapCargoTempLogDate(bm));
};

export const mapCargoTempLogDateBm = (vm: CargoTemperatureLogDate): CargoTemperatureLogDateBM => {
    return {
        logDateId: vm.logDateId,
        imoNumber: vm.imoNumber,
        logDate: formatQueryDateOnly(vm.logDate),
        isComplete: vm.isComplete,
        lastUpdatedUtc: vm.lastUpdatedUtc,
        lastUpdatedBy: vm.lastUpdatedBy,
        cargoInTankList: vm.cargoInTankList,
        cargoTemperatureLog: vm.cargoTemperatureLog ? mapCargoTemperatureLogBms(vm.cargoTemperatureLog) : null,
    };
};

export const mapCargoTempLogDateBms = (vms: CargoTemperatureLogDate[]): CargoTemperatureLogDateBM[] =>
    vms ? vms.map((vm) => mapCargoTempLogDateBm(vm)) : [];

const addOfflineDataToCargoTempLogDates = (bms: CargoTemperatureLogDateBM[], offlineCargoTempLogDates: any[]) => {
    offlineCargoTempLogDates.forEach((offlineCargoTempLogDate) => {
        const saveCargoTemperatureLogRequest = offlineCargoTempLogDate.saveCargoTemperatureLogRequest;

        if (saveCargoTemperatureLogRequest) {
            const cargoTemperatureLogResponse = saveCargoTemperatureLogRequest.response;
            const indexOfBM = bms.findIndex((bm) => bm.logDate === cargoTemperatureLogResponse.logDate);

            if (indexOfBM > -1) {
                bms[indexOfBM] = cargoTemperatureLogResponse;
            } else {
                bms.push(cargoTemperatureLogResponse);
            }
        }
    });
};
